module.exports = __webpack_public_path__ + "img/hydra.fe93a915.svg";